<template>
  <div>
    <!-- <h1>素材统计</h1> -->
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'statistics'

}
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/views/report/statistics.vue